import React from 'react';
import PropTypes from 'prop-types';

import DefaultStartPage from './default-start-page';
import PerformerStartPage from './performer-start-page';
import SectionsStartPage from './sections-start-page';
import { DEFAULT, PERFORMER, SECTIONS } from '../../constants/start-page';
import { sectionPropType } from '../../lib/prop-types';

const selectStartPageComponent = (firstPage) => {
    switch (firstPage) {
        case PERFORMER:
            return PerformerStartPage;
        case SECTIONS:
            return SectionsStartPage;
        default:
            return DefaultStartPage;
    }
};

const StartPage = ({
    assignmentEndDate,
    assignmentId,
    attemptsNumber,
    correctable,
    courseId,
    exercisesTitle,
    expiringAssignment,
    firstPage,
    getStatusArray,
    homeworkChapter,
    isChecked,
    isGeneratedHomework,
    isLoading,
    journey,
    maxAttemptsNumber,
    onChange,
    pausable,
    phase,
    publicTitle,
    remainingTime,
    scoreModifier,
    source,
    time,
    sections,
}) => {
    const StartPageComponent = selectStartPageComponent(firstPage);
    return (
        StartPageComponent && (
            <StartPageComponent
                courseId={courseId}
                assignmentEndDate={assignmentEndDate}
                assignmentId={assignmentId}
                attemptsNumber={attemptsNumber}
                correctable={correctable}
                exercisesTitle={exercisesTitle}
                expiringAssignment={expiringAssignment}
                firstPage={firstPage}
                getStatusArray={getStatusArray}
                homeworkChapter={homeworkChapter}
                isChecked={isChecked}
                isGeneratedHomework={isGeneratedHomework}
                isLoading={isLoading}
                journey={journey}
                maxAttemptsNumber={maxAttemptsNumber}
                onChange={onChange}
                pausable={pausable}
                phase={phase}
                publicTitle={publicTitle}
                remainingTime={remainingTime}
                scoreModifier={scoreModifier}
                source={source}
                time={time}
                sections={sections}
            />
        )
    );
};

StartPage.propTypes = {
    assignmentEndDate: PropTypes.string,
    assignmentId: PropTypes.string,
    attemptsNumber: PropTypes.number,
    correctable: PropTypes.bool,
    courseId: PropTypes.string,
    exercisesTitle: PropTypes.array,
    expiringAssignment: PropTypes.string,
    firstPage: PropTypes.oneOf([PERFORMER, SECTIONS, DEFAULT, '']),
    getStatusArray: PropTypes.func,
    homeworkChapter: PropTypes.string,
    isChecked: PropTypes.bool,
    isGeneratedHomework: PropTypes.bool,
    isLoading: PropTypes.bool,
    journey: PropTypes.string,
    maxAttemptsNumber: PropTypes.number,
    onChange: PropTypes.func,
    pausable: PropTypes.bool,
    phase: PropTypes.string,
    publicTitle: PropTypes.string,
    remainingTime: PropTypes.number,
    scoreModifier: PropTypes.object,
    source: PropTypes.string,
    time: PropTypes.number,
    sections: PropTypes.arrayOf(sectionPropType),
};

export default StartPage;
